function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKosher = function SvgKosher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M315 183.5a154 172.5 0 1 1-308 0 154 172.5 0 1 1 308 0",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.45899999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.2987 0 0 1.15942 -9.09 -12.754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 178.5a154.5 166.5 0 1 1-309 0 154.5 166.5 0 1 1 309 0z",
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: 34.39592743,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.16914 0 0 1.08487 -5.183 6.35)"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 91.665,
    y: 313.938,
    style: {
      fontSize: "313.28573608px",
      fontStyle: "normal",
      fontWeight: 700,
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      fontFamily: "Arial Black"
    },
    transform: "scale(.9825 1.01782)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 91.665,
    y: 313.938,
    style: {
      fontStyle: "normal",
      fontWeight: 700,
      fill: "#000",
      fillOpacity: 1,
      fontFamily: "Arial"
    }
  }, "U")));
};
export { SvgKosher as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMCIgd2lkdGg9IjQwMCIgaGVpZ2h0PSI0MDAiIGlkPSJzdmcyIj4NCiAgPGRlZnMgaWQ9ImRlZnM0Ii8+DQogIDxnIGlkPSJsYXllcjEiPg0KICAgIDxwYXRoIGQ9Ik0gMzE1IDE4My41IEEgMTU0IDE3Mi41IDAgMSAxICA3LDE4My41IEEgMTU0IDE3Mi41IDAgMSAxICAzMTUgMTgzLjUgeiIgdHJhbnNmb3JtPSJtYXRyaXgoMS4yOTg3MDEsMCwwLDEuMTU5NDIsLTkuMDkwODYxLC0xMi43NTM1NykiIHN0eWxlPSJvcGFjaXR5OjE7ZmlsbDp3aGl0ZTtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZTtzdHJva2Utd2lkdGg6MC40NTg5OTk5OTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46bWl0ZXI7c3Ryb2tlLW1pdGVybGltaXQ6NDtzdHJva2UtZGFzaGFycmF5Om5vbmU7c3Ryb2tlLW9wYWNpdHk6MSIgaWQ9InBhdGgxODcyIi8+DQogICAgPHBhdGggZD0iTSAzMzAgMTc4LjUgQSAxNTQuNSAxNjYuNSAwIDEgMSAgMjEsMTc4LjUgQSAxNTQuNSAxNjYuNSAwIDEgMSAgMzMwIDE3OC41IHoiIHRyYW5zZm9ybT0ibWF0cml4KDEuMTY5MTM2LDAsMCwxLjA4NDg3MywtNS4xODMzNjgsNi4zNTAxNjkpIiBzdHlsZT0ib3BhY2l0eToxO2ZpbGw6bm9uZTtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6YmxhY2s7c3Ryb2tlLXdpZHRoOjM0LjM5NTkyNzQzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjptaXRlcjtzdHJva2UtbWl0ZXJsaW1pdDo0O3N0cm9rZS1kYXNoYXJyYXk6bm9uZTtzdHJva2Utb3BhY2l0eToxIiBpZD0icGF0aDI3NjAiLz4NCiAgICA8dGV4dCB4PSI5MS42NjUwOTIiIHk9IjMxMy45Mzc2OCIgdHJhbnNmb3JtPSJzY2FsZSgwLjk4MjQ5MywxLjAxNzgxOSkiIHN0eWxlPSJmb250LXNpemU6MzEzLjI4NTczNjA4cHg7Zm9udC1zdHlsZTpub3JtYWw7Zm9udC13ZWlnaHQ6Ym9sZDtmaWxsOmJsYWNrO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lO3N0cm9rZS13aWR0aDoxcHg7c3Ryb2tlLWxpbmVjYXA6YnV0dDtzdHJva2UtbGluZWpvaW46bWl0ZXI7c3Ryb2tlLW9wYWNpdHk6MTtmb250LWZhbWlseTpBcmlhbCBCbGFjayIgaWQ9InRleHQ1NDE3IiB4bWw6c3BhY2U9InByZXNlcnZlIj48dHNwYW4geD0iOTEuNjY1MDkyIiB5PSIzMTMuOTM3NjgiIHN0eWxlPSJmb250LXN0eWxlOm5vcm1hbDtmb250LXdlaWdodDpib2xkO2ZpbGw6YmxhY2s7ZmlsbC1vcGFjaXR5OjE7Zm9udC1mYW1pbHk6QXJpYWwiIGlkPSJ0c3BhbjU0MTkiPlU8L3RzcGFuPjwvdGV4dD4NCiAgPC9nPg0KPC9zdmc+";